//Dashboard Advertiser
const Dashboard = () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard')
//// import HostReport from "./views/Dashboard/Host/Report"

//Advertiser 
const Advertiser = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser')
// const AdvertiserDigitalScreen = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/DigitalScreen')
// const AdvertiserStatic = () => import(/* webpackChunkName: "Advertiser" */ '../views/Monitoring/Campaign')
const AdvertiserStatic = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/StaticCampaign')

// detail page
const DetailStatic = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/StaticCampaign/Detail')
const DigitalScrDetail = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/StaticCampaign/Detail/DigitalScreenDetail')
const ExBrandingDetail = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/StaticCampaign/Detail/ExBrandingDetail')

//measurement page
const MeasurementStatic = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/StaticCampaign/Monitoring')

//monitoroing page
const MonitoringStatic = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/StaticCampaign/Monitoring')
const DigitalScrMonitoring = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/StaticCampaign/Monitoring/DigitalScrMonitoring')
const ExBrandMonitoring = () => import(/* webpackChunkName: "MonitoringDetail" */ '../views/Dashboard/Advertiser/StaticCampaign/Monitoring/ExBrandMonitoring')

const AdvertiserBus = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/BusAdvertising')
const AdvertiserBusTemp = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/BusAdvertisingTemp')
const BusCampaignDetail = () => import(/* webpackChunkName: "Advertiser" */ '../views/Dashboard/Advertiser/BusAdvertising/BusDetail')
const BusReport = () => import(/* webpackChunkName: "DashboardAdvertiserReport" */ '../views/Dashboard/Advertiser/BusAdvertising/CampaignReportBus')
const BusReportRoutes = () => import(/* webpackChunkName: "Routes" */ '../views/Dashboard/Advertiser/BusAdvertising/CampaignReportBus/Routes')
const BusReportVehicle = () => import(/* webpackChunkName: "Routes" */ '../views/Dashboard/Advertiser/BusAdvertising/CampaignReportBus/Vehicle')
const BusReportCoverage = () => import(/* webpackChunkName: "Routes" */ '../views/Dashboard/Advertiser/BusAdvertising/CampaignReportBus/Coverage')
const CampaignReportList = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReportList')
const CampaignReport = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReport')
const CampaignReportV2 = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReportV2')
const CampaignReportV2Location = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReportV2/Location')
const CampaignReportV2Age = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReportV2/Age')
const CampaignReportV2Gender = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReportV2/Gender')
const CampaignReportV2Ses = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReportV2/Ses')
const CampaignReportV2Vehicle = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReportV2/Vehicle')
const Audience = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReport/Audience')
const ImpactDashboard = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReport/Impact')
const Demographic = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReport/Demographic')
const Gender = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReport/Demographic/Gender')
const Age = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReport/Demographic/Age')
const Interest = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReport/Demographic/Interest')
const OperatingSystem = () => import(/* webpackChunkName: "CampaignReport" */ '../views/Dashboard/Advertiser/CampaignReport/Demographic/OperatingSystem')
const CampaignDetail = () => import(/* webpackChunkName: "CampaignDetail" */ '../views/Dashboard/CampaignDetail')
const CampaignContents = () => import(/* webpackChunkName: "CampaignContents" */ '../views/Dashboard/CampaignContents')
const CampaignContentsSuccess = () => import(/* webpackChunkName: "CampaignContentsSuccess" */ '../views/Dashboard/CampaignContents/Success')

// New Bus Measurement
const MeasurementBus = () => import(/* webpackChunkName: "DashboardAdvertiserReport" */ '../views/Dashboard/Advertiser/BusAdvertising/Measurement')
const MeasurementBusCoverage = () => import(/* webpackChunkName: "DashboardAdvertiserReport" */ '../views/Dashboard/Advertiser/BusAdvertising/Measurement/Coverage')
const MeasurementBusRoutes = () => import(/* webpackChunkName: "DashboardAdvertiserReport" */ '../views/Dashboard/Advertiser/BusAdvertising/Measurement/Routes')
const MeasurementBusVehicle = () => import(/* webpackChunkName: "DashboardAdvertiserReport" */ '../views/Dashboard/Advertiser/BusAdvertising/Measurement/Vehicle')

//Host
const HostReport = () => import(/* webpackChunkName: "HostReport" */ '../views/Dashboard/Host/Report')
const HostListings = () => import(/* webpackChunkName: "HostListings" */ '../views/Dashboard/Host/Listing')
const HostSchedules = () => import(/* webpackChunkName: "HostSchedules" */ '../views/Dashboard/Host/Schedules')
const HostSchedulesManage = () => import(/* webpackChunkName: "HostSchedulesManage" */ '../views/Dashboard/Host/Schedules/Manage')
const HostSchedulesUpload = () => import(/* webpackChunkName: "HostSchedulesUpload" */ '../views/Dashboard/Host/Schedules/Upload')
const HostCampaign = () => import(/* webpackChunkName: "HostCampaign" */ '../views/Dashboard/Host/Campaign')
const HostCampaignDetail = () => import(/* webpackChunkName: "HostCampaignDetail" */ '../views/Dashboard/Host/Campaign/CampaignDetail')

//Monitoring
// const AllMonitoring = () => import(/* webpackChunkName: "Monitoring" */ '../views/Monitoring')
// const MonitoringCampaign = () => import(/* webpackChunkName: "Monitoring" */ '../views/Monitoring/Campaign')
// const MonitoringBusCampaign = () => import(/* webpackChunkName: "MonitoringBusCampaign" */ '../views/Monitoring/BusCampaign')
// const MonitoringDetail = () => import(/* webpackChunkName: "MonitoringDetail" */ '../views/Monitoring/MonitoringDetail')
const MonitoringBusDetail = () => import(/* webpackChunkName: "MonitoringBus" */ '../views/Monitoring/MonitoringBusDetail')

//Media Library
const DashboardMediaLibrary = () => import(/* webpackChunkName: "DashboardMediaLibrary" */ '../views/Dashboard/MediaLibrary')

//Account
const Transaction = () => import(/* webpackChunkName: "Transaction" */ '../views/Transaction')
const TransactionHistory = () => import(/* webpackChunkName: "TransactionHistory" */ '../views/Dashboard/Account/TransactionHistory')
const InvoiceAnon = () => import(/* webpackChunkName: "Invoice" */ '../views/Transaction/InvoiceAnon')
const Invoice = () => import(/* webpackChunkName: "Invoice" */ '../views/Transaction/Invoice')
const Order = () => import(/* webpackChunkName: "Order" */ '../views/Transaction/Order')
const OrderDetail = () => import(/* webpackChunkName: "OrderDetail" */ '../views/OrderDetail')
const OrderDetailSuccess = () => import(/* webpackChunkName: "OrderDetail" */ '../views/OrderDetail/Success')
const TransactionDigital = () => import(/* webpackChunkName: "Digital" */ '../views/Transaction/Digital')
const TransactionDigitalAdvertising = () => import(/* webpackChunkName: "DigitalAdvertising" */ '../views/Transaction/DigitalAdvertising')
const TransactionBus = () => import(/* webpackChunkName: "Digital" */ '../views/Transaction/BusAdvertising')
const PayoutPreferences = () => import(/* webpackChunkName: "PayoutPreferences" */ '../views/Dashboard/Account/PayoutPreferences')
const BalanceHistory = () => import(/* webpackChunkName: "BalanceHistory" */ '../views/Dashboard/BalanceHistory')
const CampaignHostRevenue = () => import(/* webpackChunkName: "CampaignHostRevenue" */ '../views/Dashboard/CampaignHostRevenue')
const EditProfile = () => import(/* webpackChunkName: "EditProfile" */ '../views/Dashboard/Account/EditProfile')
const Receipt = () => import(/* webpackChunkName: "Receipt" */ '../views/Payment/Receipt')
const PaymentError = () => import(/* webpackChunkName: "PaymentError" */ '../views/Payment/Failed')
const EmailNotification = () => import(/* webpackChunkName: "EmailNotification" */ '../views/Account/Verification')
const SignupSuccess = () => import(/* webpackChunkName: "SignupSuccess" */ '../views/Account/Success')
const Signin = () => import(/* webpackChunkName: "Signin" */ '../views/Account/Signin')
const Signup = () => import(/* webpackChunkName: "Signup" */ '../views/Account/Signup')
const Forgot = () => import(/* webpackChunkName: "Forgot" */ '../views/Account/Forgot')
const SocialLogin = () => import(/* webpackChunkName: "SocialLogin" */ '../views/Account/Social')
const ForgotNewPassword = () => import(/* webpackChunkName: "ForgotNewPassword" */ '../views/Account/NewPassword')
const ForgotSuccess = () => import(/* webpackChunkName: "ForgotSuccess" */ '../views/Account/PasswordChanged')
const SetNewPassword = () => import(/* webpackChunkName: "SetNewPassword" */ '../views/Account/NewPassword')


const dashboardRoute = [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      redirect: { name: 'advertiser' },
      meta: { requiresAuth: true },
      children: [
          {
            path: 'advertiser',
            name: 'advertiser',
            component: Advertiser,
            redirect: { name: 'advertiserstatic' },
            meta: { requiresAuth: true },
            children: [
              // {
              //   path: 'advertiserdigitalscreen',
              //   name: 'advertiserdigitalscreen',
              //   component: AdvertiserDigitalScreen,
              //   meta: { requiresAuth: true }
              // },
              {
                // path: 'advertiserstatic',
                path: 'advertiserstatic',
                name: 'advertiserstatic',
                component: AdvertiserStatic,
                meta: { requiresAuth: true },
              },
              {
                path: 'advertiserbus',
                name: 'advertiserbus',
                component: AdvertiserBus,
                meta: { requiresAuth: true }
              },
              {
                path: 'bustemp',
                name: 'bustemp',
                component: AdvertiserBusTemp,
                meta: { requiresAuth: true }
              },
            ]
          },
          {
            path: 'detailstatic',
            name: 'detailstatic',
            component: DetailStatic,
            redirect: { name: 'digitalscrdetail' },
            meta: { requiresAuth: true },
            children: [
              {
                path: 'digitalscreen-detail/:id',
                name: 'digitalscrdetail',
                component: DigitalScrDetail,
                meta: { requiresAuth: true }
              },
              {
                path: 'exbranding-detail/:id',
                name: 'exbrandingdetail',
                component: ExBrandingDetail,
                meta: { requiresAuth: true }
              },
            ]
          },
          {
            path: 'measurement-static',
            name: 'measurementstatic',
            component: MeasurementStatic,
            redirect: { name: 'campaignreportv2' },
            meta: { requiresAuth: true },
          },
          {
            path: 'monitoring-static',
            name: 'monitoringstatic',
            component: MonitoringStatic,
            redirect: { name: 'digitalscrmonitoring' },
            meta: { requiresAuth: true },
            children: [
              {
                path: 'digitalscreen-monitoring/:id',
                name: 'digitalscrmonitoring',
                component: DigitalScrMonitoring,
                meta: { requiresAuth: true }
              },
              {
                path: 'exbranding-monitoring/:id',
                name: 'exbrandmonitoring',
                component: ExBrandMonitoring,
                meta: { requiresAuth: true }
              },
            ]
          },
          {
            path: 'advertiser/advertiserdigitalscreen/campaign/:id',
            name: 'campaigndetail',
            component: CampaignDetail,
            meta: { requiresAuth: true }
          },
          // {
          //   path: 'advertiser/advertiserstatic/monitoringdetail/:id',
          //   name: 'monitoringdetail',
          //   component: MonitoringDetail,
          //   meta: { requiresAuth: true }
          // },
          {
            path: 'advertiser/advertiserbus/monitoringbusdetail/:id',
            name: 'monitoringbusdetail',
            component: MonitoringBusDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'advertiser/digitalscreen-detail/campaigncontentssuccess',
            name: 'campaigncontentssuccess',
            component: CampaignContentsSuccess,
            meta: { requiresAuth: true }
          },
          {
            path: 'advertiser/digitalscreen-detail/campaigncontents/:id',
            name: 'campaigncontents',
            component: CampaignContents,
            meta: { requiresAuth: true }
          },
          {
            path: 'advertiser/advertiserdigitalscreen/campaignreportv2/',
            name: 'campaignreportlist',
            component: CampaignReportList,
            meta: { requiresAuth: true }
          },
          {
            path: 'advertiser/advertiserdigitalscreen/campaignreport/:campaign_id',
            name: 'campaignreport',
            component: CampaignReport,
            redirect: { name: 'audience' },
            meta: { requiresAuth: true },
            children: [
              {
                path: 'audience',
                name: 'audience',
                component: Audience,
                meta: { requiresAuth: true }
              },
              {
                path: 'impactdashboard',
                name: 'impactdashboard',
                component: ImpactDashboard,
                meta: { requiresAuth: true }
              },
              {
                path: 'demographic',
                name: 'demographic',
                component: Demographic,
                redirect: { name: 'gender' },
                meta: { requiresAuth: true },
                children: [
                  {
                    path: 'gender',
                    name: 'gender',
                    component: Gender,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'age',
                    name: 'age',
                    component: Age,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'interest',
                    name: 'interest',
                    component: Interest,
                    meta: { requiresAuth: true }
                  },
                  {
                    path: 'operatingsystem',
                    name: 'operatingsystem',
                    component: OperatingSystem,
                    meta: { requiresAuth: true }
                  }
                ]
              }
            ]
          },
          {
            path: 'advertiser/campaignreportv2/:campaign_id',
            name: 'campaignreportv2',
            component: CampaignReportV2,
            redirect: { name: 'campaignreportv2-location' },
            meta: { requiresAuth: true },
            children: [
              {
                path: 'location',
                name: 'campaignreportv2-location',
                component: CampaignReportV2Location,
                meta: { requiresAuth: true }
              },
              {
                path: 'age',
                name: 'campaignreportv2-age',
                component: CampaignReportV2Age,
                meta: { requiresAuth: true }
              },
              {
                path: 'gender',
                name: 'campaignreportv2-gender',
                component: CampaignReportV2Gender,
                meta: { requiresAuth: true }
              },
              {
                path: 'ses',
                name: 'campaignreportv2-ses',
                component: CampaignReportV2Ses,
                meta: { requiresAuth: true }
              },
              {
                path: 'vehicle',
                name: 'campaignreportv2-vehicle',
                component: CampaignReportV2Vehicle,
                meta: { requiresAuth: true }
              },
            ]
          },
          {
            path: 'advertiser/advertiserbus/measurement/:id',
            name: 'measurementbus',
            component: MeasurementBus,
            redirect: { name: 'measurementbusroutes' },
            meta: { requiresAuth: true },
            children: [
              {
                path: 'routes',
                name: 'measurementbusroutes',
                component: MeasurementBusRoutes,
                props: true,
                meta: { requiresAuth: true }
              },
              {
                path: 'vehicle',
                name: 'measurementbusvehicle',
                component: MeasurementBusVehicle,
                meta: { requiresAuth: true }
              },
              {
                path: 'coverage',
                name: 'measurementbuscoverage',
                component: MeasurementBusCoverage,
                meta: { requiresAuth: true }
              },
            ]
          },
          {
            path: 'advertiser/advertiserbus/buscampaigndetail/:id',
            name: 'buscampaigndetail',
            component: BusCampaignDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'media-library',
            name: 'media-library',
            component: DashboardMediaLibrary,
            meta: { requiresAuth: true }
          },
          {
            path: 'host/report',
            name: 'hostReport',
            component: HostReport,
            meta: { requiresAuth: true }
          },
          {
            path: 'host/listings/',
            name: 'hostlistings',
            component: HostListings,
            meta: { requiresAuth: true }
          },
          {
            path: 'account/transactionhistory',
            name: 'transactionhistory',
            component: TransactionHistory,
            meta: { requiresAuth: true }
          },
          {
            path: '/dashboard/host/schedules/',
            name: 'hostschedules',
            component: HostSchedules,
            meta: { requiresAuth: true }
          },
          {
            path: '/dashboard/host/schedules/manage',
            name: 'hostschedulesmanage',
            component: HostSchedulesManage,
            meta: { isGrazilla: true },
          },
          {
            path: '/dashboard/host/schedules/upload',
            name: 'hostschedulesupload',
            component: HostSchedulesUpload,
            meta: { requiresAuth: true }
          },
          {
            path: '/dashboard/host/campaign/',
            name: 'hostcampaign',
            component: HostCampaign,
            meta: { requiresAuth: true }
          },
          {
            path: '/dashboard/host/campaign/:id',
            name: 'hostcampaigndetail',
            component: HostCampaignDetail,
            meta: { requiresAuth: true }
          },
          {
            path: 'account/payoutpreferences',
            name: 'payoutpreferences',
            component: PayoutPreferences,
            meta: { requiresAuth: true }
          },
          {
            path: 'balance-history',
            name: 'balancehistory',
            component: BalanceHistory,
            meta: { requiresAuth: true }
          },
          {
            path: 'campaign-host-revenue',
            name: 'campaignhostrevenue',
            component: CampaignHostRevenue,
            meta: { requiresAuth: true }
          },
        ]
    },
    {
      path: '/dashboard/account/edit-profile',
      name: 'editprofile',
      component: EditProfile,
      meta: { requiresAuth: true }
    },
    {
      path: '/invoice/:uid',
      name: 'invoice-anon',
      component: InvoiceAnon
    },   
    {
      path: '/transaction',
      name: 'transaction',
      component: Transaction,
      meta: { requiresAuth: true },
      redirect: { name: 'transactiondigital' },
      children: [
          {
            path: 'digital',
            name: 'transactiondigital',
            component: TransactionDigital,
            meta: { requiresAuth: true }
          },
          {
            path: 'digitaladvertising',
            name: 'transactiondigitaladvertising',
            component: TransactionDigitalAdvertising,
            meta: { requiresAuth: true }
          },
          {
            path: 'busadvertising',
            name: 'transactionbus',
            component: TransactionBus,
            meta: { requiresAuth: true }
          },
        ]
    },
    {
      path: '/transaction/invoice/:invoice_id',
      name: 'invoicereceipt',
      component: Invoice,
      meta: { requiresAuth: true }
    },
    {
      path: '/transaction/order/:order_id',
      name: 'orderreceipt',
      component: Order,
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/receipt/:receipt_id',
      name: 'paymentreceipt',
      component: Receipt,
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/error',
      name: 'paymenterror',
      component: PaymentError
    },
    {
      path: '/order/success',
      name: 'orderdetailsuccess',
      component: OrderDetailSuccess,
      meta: { requiresAuth: true }
    },
    {
      path: '/order/:id',
      name: 'orderdetail',
      component: OrderDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/email-notification/',
      name: 'emailnotification',
      component: EmailNotification
    },
    {
      path: '/signin/',
      name: 'signin',
      component: Signin,
      meta: { isLogin: true }
    },
    {
      path: '/signup/',
      name: 'signup',
      component: Signup,
      meta: { isLogin: true }
    },
    {
      path: '/signup/success',
      name: 'signup-success',
      component: SignupSuccess
    },
    {
      path: '/forgot-password/',
      name: 'forgot',
      component: Forgot,
      meta: { isLogin: true }
    },
    {
      path: '/social-login',
      name: 'sociallogin',
      component: SocialLogin,
      meta: { isLogin: true }
    },
    {
      path: '/forgot-password/change',
      name: 'forgotnewpassword',
      component: ForgotNewPassword,
      meta: { isLogin: true }
    },
    {
      path: '/forgot-password/success',
      name: 'forgotsuccess',
      component: ForgotSuccess,
      meta: { isLogin: true }
    },
    {
      path: '/set-new-password/change',
      name: 'setnewpassword',
      component: SetNewPassword,
      meta: { isLogin: true }
    },
]

export default dashboardRoute;
